import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(25),
    flexBasis: "33.33%",
    flexShrink: 0,
    fontWeight: "400",
    color: "rgb(65,65,85)",
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  badge: {
    display: "flex",
    alignItems: "center",
    fontSize: "15px",
    marginInline: "5px",
  },
}));

export default function SimpleAccordion({
  data,
  title,
  setOldValue,
  oldValue,
}) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = () => {
    setExpanded(!expanded);
  };

  const handleChanges = (event) => {
    const { checked, value } = event.currentTarget;

    setOldValue((prev) =>
      checked
        ? [...prev, Number(value)]
        : prev.filter((val) => val !== Number(value))
    );
  };
  console.log(data, "hgdfg");
  return (
    <ExpansionPanel
      expanded={expanded}
      onChange={handleChange}
      className="mt-3"
    >
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <Typography
          className={`${classes.heading} d-flex flex-grow-1 align-items-center justify-content-start ml-5`}
        >
          {title}
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className="d-flex flex-wrap">
        <Table aria-labelledby="tableTitle">
          <TableHead>
            <TableRow>
              <TableCell>İcazə başlığı</TableCell>
              <TableCell>İcazə ver</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row, index) => {
              const labelId = `enhanced-table-checkbox-${index}`;
              return (
                <TableRow tabIndex={-1} key={row.value}>
                  <TableCell component="th" id={labelId} scope="row">
                    {row.label}
                  </TableCell>

                  <TableCell>
                    <Tooltip title="icazə" className="mr-4">
                      <FormControlLabel
                        control={
                          <Checkbox
                            value={Number(row.value)}
                            checked={oldValue.some((val) => val === row.value)}
                            onChange={handleChanges}
                          />
                        }
                      />
                    </Tooltip>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
}
